__turbopack_context__.v({
  "circle": "ProgressWheel-module-scss-module__KIt1ya__circle",
  "text": "ProgressWheel-module-scss-module__KIt1ya__text",
});
